// notificationsClient.js
import axios from "axios";
import config from "./config";
import { getToken } from "firebase/messaging";
import { getMessagingSafe } from "./firebaseConfig"; // from your adjusted file

import i18n from "./i18n";
const tr = i18n.t.bind(i18n);
function isIOS() { return /iPhone|iPad|iPod/.test(navigator.userAgent); }
function inStandalone() { return window.matchMedia('(display-mode: standalone)').matches; }

export async function enablePush() {
  // iOS must be opened from Home Screen (PWA)
  if (isIOS() && !inStandalone()) {
    alert("On iPhone, add this app to your Home Screen first (Share > Add to Home Screen), then open it and tap Enable again.");
    return null;
  }

  // Must be a user gesture calling this function (click/tap)
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  // Register SW (ensure it�s at the site root, e.g., /firebase-messaging-sw.js)
  const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;

  // Get FCM token
  const messaging = await getMessagingSafe();
  const token = await getToken(messaging, {
    vapidKey: "BOtio-4U8ct6Q36KkxvjXY1wpzEDnYPpe-SBzJbqckTbnh_bLy5ue4RsroVxjQSR9xmntjCEnLWxt8YPMX6Le8o",
    serviceWorkerRegistration: reg
  });
  if (!token) return null;

  // Save token to your backend (requires session cookie)
  await axios.post(tr('{{API_BASE_URL}}/users/token', {
    API_BASE_URL: config.API_BASE_URL
  }), { token }, { withCredentials: true });
  localStorage.setItem("pushEnabled", "true");
  return token;
}

export function shouldShowPrompt() {
  if (!("Notification" in window)) return false; // no support
  if (Notification.permission === "granted") return false;
  if (localStorage.getItem("notifPromptDismissed") === "true") return false;
  // Show on iOS only if in PWA; for others show anytime
  if (isIOS()) return inStandalone(); 
  return true;
}

export function dismissPrompt() {
  localStorage.setItem("notifPromptDismissed", "true");
}
